
(function () {
  // Seguimiento de clics de Gaia Baby
  // Por ahora solo registra datos para comprobarlos.
  // No envía información a Google Analytics.

  document.addEventListener('click', function (event) {
    const element = event.target.closest('a, button, summary');
    if (!element) return;

    const header = element.closest('header');
    const mobileMenu = element.closest('.menu-drawer, .header-drawer, .drawer, [id*="menu-drawer"], [class*="header-nav-drawer"]');
    const link = element.closest('a[href]');

    let category = 'other';

    if (header || mobileMenu) {
      category = 'navigation';
    } else if (window.location.pathname === '/') {
      category = 'homepage';
    }

    const clickData = {
      event: 'gaia_click',
      category: category,
      text: (element.innerText || element.getAttribute('aria-label') || '')
        .trim()
        .substring(0, 100),
      url: link ? link.getAttribute('href') : '',
      device: window.innerWidth < 768 ? 'mobile' : 'desktop'
    };
if (
  !window.Shopify ||
  !window.Shopify.customerPrivacy ||
  !window.Shopify.customerPrivacy.analyticsProcessingAllowed()
) {
  return;
}

    console.log('Gaia Baby Click Tracking:', clickData);
    window.dataLayer = window.dataLayer || [];

window.dataLayer.push({
  event: 'gaia_click',
  click_category: clickData.category,
  click_text: clickData.text,
  click_url: clickData.url,
  click_device: clickData.device
});
  });
})();
